import type { ReactNode } from 'react';

interface AlertProps {
  variant?: 'success' | 'error' | 'info' | 'warning';
  title?: string;
  children?: ReactNode;
}

const variantClasses: Record<string, string> = {
  success: 'bg-green-50 border-green-200 text-green-800',
  error: 'bg-red-50 border-red-200 text-red-800',
  info: 'bg-blue-50 border-blue-200 text-blue-800',
  warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
};

export function Alert({ variant = 'info', title, children }: AlertProps) {
  return (
    <div className={`rounded-md border p-3 text-sm ${variantClasses[variant]}`}>
      {title && <p className="font-semibold mb-0.5">{title}</p>}
      {children && <div>{children}</div>}
    </div>
  );
}
